import { useMemo } from 'react';
import './styles.css';
import { useLocalStorage } from 'ui/hooks/useLocalStorage';

export const TicketsCounter = ({ className }: { className?: string }) => {
    const [tickets] = useLocalStorage<number>('stories_tickets_counter', 0);

    const ticketsValue = useMemo(() => {
        if (!tickets) {
            return 0;
        }

        const valueInt = parseInt(tickets);

        if (valueInt > 99) {
            return '99+';
        }

        return valueInt;
    }, [tickets]);

    return (
        <div className={`stories-ticket-counter ${className}`}>
            <picture>
                <source srcSet="/assets/stories/ticket.webp" type="image/webp" />
                <img className="stories-ticket-image" src="/assets/stories/ticket.png"/>
            </picture>
            <span>{ticketsValue}</span>
        </div>
    )
}